export const PRIVATE = 'PRIVATE';
export const INTERNAL = 'INTERNAL';
